import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { Block, Heading, Text } from '../../../../../../../components';
import { InteractiveButton } from '../../../../../components';
import confQuit from '../../../../../../../../assets/illustrations/confirmation-quit.svg';

interface ConfirmationQuitProps {
  handleQuit: () => void;
  handleCancel: () => void;
}
const ConfirmationQuit: React.FC<ConfirmationQuitProps> = (props) => {
  const { handleQuit, handleCancel } = props;
  return (
    <>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="0px 39px 32px 38px"
        margin="12px 0px 0px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Block
          customized
          display="flex"
          justifyContent="center"
          alignItems="center"
          margin="0px 0px 16px"
        >
          <img src={confQuit} alt="trash" />
        </Block>
        <Heading
          text="¿Deseas salir de esta página?"
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        <Block
          customized
          margin="16px 0px 0px 0px"
          alignItems="center"
          justifyContent="center"
        >
          <Text fontSize="14px" lineHeight="20px" textAlign="center">
            Recuerda que los cambios realizados no se guardarán.
          </Text>
        </Block>
        <Block
          customized
          flexDirection={isMobile ? 'column' : 'row'}
          alignItems="center"
          margin="40px 0px 0px 0px"
          justifyContent="center"
        >
          <InteractiveButton
            bkgColorEnabled="#5B36F2"
            bkgColorHover="#745EF6"
            bkgColorFocus="#4318CD"
            bkgColorPressed="#4318CD"
            customized
            alignItems="center"
            backgroundColor="#5B36F2"
            padding="10px 0px"
            borderRadius="4px"
            width={isMobile ? '100%' : '99px'}
            onClick={handleQuit}
          >
            <Text
              color="#FFFFFF"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              Sí, salir
            </Text>
          </InteractiveButton>
          <InteractiveButton
            bkgColorEnabled="none"
            bkgColorHover="#E2DFFD"
            bkgColorFocus="#C6C0FC"
            bkgColorPressed="#C6C0FC"
            customized
            border="1px solid #5B36F2"
            alignItems="center"
            backgroundColor="#FFFFFF"
            padding="9px 0px"
            margin={isMobile ? '12px 0px 0px 0px' : '0px 0px 0px 16px'}
            borderRadius="4px"
            width={isMobile ? '100%' : '87px'}
            onClick={handleCancel}
          >
            <Text
              color="#5B36F2"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="700"
              textAlign="center"
            >
              Cancelar
            </Text>
          </InteractiveButton>
        </Block>
      </Block>
    </>
  );
};

export default ConfirmationQuit;
